import ActionMenu from "./ActionMenu";
import DeConsumerMessage from "./DeConsumerMessage";
import Logo from "../Logo/Logo";
import Menu from "./Menu";
import { useState } from "preact/compat";
import { SkipNav, UsaBanner } from '@cmsgov/design-system';
import { t } from "../i18n";
import classnames from 'classnames';
import defaultMenuLinks from "./defaultMenuLinks";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "preact/compat/jsx-runtime";
export const VARIATION_NAMES = {
  LOGGED_IN: 'logged-in',
  LOGGED_OUT: 'logged-out'
};

/**
 * For information about how and when to use this component,
 * [refer to its full documentation page](https://design.cms.gov/components/header/healthcare-header/?theme=healthcare).
 */
export const Header = props => {
  const {
    skipNavHref = '#main'
  } = props;
  const isControlledMenu = props.isMenuOpen !== undefined && props.onMenuToggle !== undefined;
  const [internalIsMenuOpenState, setInternalIsMenuOpenState] = useState(false);
  const isMenuOpen = isControlledMenu ? props.isMenuOpen : internalIsMenuOpenState;

  /**
   * Event handler for when the "Menu" or "Close" button
   * within ActionMenu is clicked.
   */
  function handleMenuToggleClick() {
    if (!isControlledMenu) {
      setInternalIsMenuOpenState(!isMenuOpen);
    }
    props.onMenuToggle?.();
  }
  const variation = props.loggedIn ? VARIATION_NAMES.LOGGED_IN : VARIATION_NAMES.LOGGED_OUT;
  const classes = classnames(`hc-c-header hc-c-header--${variation}`, props.className);
  const hasCustomLinks = !!props.links;
  const defaultLinksForVariation = defaultMenuLinks({
    deConsumer: props.deConsumer,
    subpath: props.subpath,
    primaryDomain: props.primaryDomain,
    switchLocaleLink: props.switchLocaleLink,
    hideLoginLink: props.hideLoginLink,
    hideLogoutLink: props.hideLogoutLink,
    hideLanguageSwitch: props.hideLanguageSwitch,
    customLinksPassedIn: hasCustomLinks,
    loginLinkClassName: props.loginLinkClassName,
    languageLinkClassName: props.languageLinkClassName
  })[variation];
  const links = hasCustomLinks ? props.links.concat(defaultLinksForVariation) : defaultLinksForVariation;
  const beforeMenuLinks = props.loggedIn && props.firstName ? /*#__PURE__*/_jsx("div", {
    className: "ds-u-sm-display--none ds-u-border-bottom--1 ds-u-margin-x--1 ds-u-padding-y--1 hc-c-header__name",
    children: props.firstName
  }) : undefined;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SkipNav, {
      href: skipNavHref,
      onClick: props.onSkipNavClick,
      children: t('header.skipNav')
    }), /*#__PURE__*/_jsx(UsaBanner, {
      id: "hc-c-header__usa-banner"
    }), /*#__PURE__*/_jsxs("header", {
      className: classes,
      role: "banner",
      "aria-label": "global",
      children: [/*#__PURE__*/_jsx("div", {
        className: "ds-l-container",
        children: /*#__PURE__*/_jsxs("div", {
          className: "ds-l-row ds-u-align-items--center ds-u-flex-wrap--nowrap ds-u-padding-y--2",
          children: [/*#__PURE__*/_jsx("a", {
            href: props.primaryDomain ? props.primaryDomain : '/',
            className: "hc-c-logo-link ds-l-col ds-l-col--auto",
            children: /*#__PURE__*/_jsx(Logo, {
              className: props.logoClassName
            })
          }), /*#__PURE__*/_jsxs("nav", {
            "aria-label": "Profile, applications, and coverage",
            id: "hc-c-header__actions",
            className: "hc-c-header__actions ds-l-col ds-l-col--auto ds-u-margin-left--auto ds-u-font-weight--bold",
            children: [/*#__PURE__*/_jsx(ActionMenu, {
              t: t,
              firstName: props.firstName,
              onMenuToggleClick: handleMenuToggleClick,
              loggedIn: props.loggedIn,
              open: isMenuOpen,
              links: links
            }), /*#__PURE__*/_jsx(Menu, {
              beforeLinks: beforeMenuLinks,
              links: links,
              open: isMenuOpen,
              submenuTop: props.submenuTop,
              submenuBottom: props.submenuBottom
            })]
          })]
        })
      }), props.deConsumer && /*#__PURE__*/_jsx(DeConsumerMessage, {
        t: t,
        deBrokerName: props.deBrokerName
      }), props.headerBottom]
    })]
  });
};
export default Header;